module.exports = __webpack_public_path__ + "img/checkout-shoes.c12f1447.svg";